import { useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'

export const useUnsavedChangesPrompt = isDirty => {
  const history = useHistory()
  const [nextLocation, setNextLocation] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)

  const unblockRef = useRef(null)

  useEffect(() => {
    if (!isDirty) {
      if (unblockRef.current) {
        unblockRef.current()
        unblockRef.current = null
      }
      return () => {}
    }

    unblockRef.current = history.block(tx => {
      setNextLocation(tx)
      setIsModalVisible(true)
      return false
    })

    return () => {
      if (unblockRef.current) {
        unblockRef.current()
      }
    }
  }, [history, isDirty])

  const handleConfirmNavigation = () => {
    if (unblockRef.current) {
      unblockRef.current()
    }

    if (nextLocation) {
      history.push(nextLocation.pathname)
    }

    setIsModalVisible(false)
  }

  const handleCancelNavigation = () => {
    setNextLocation(null)
    setIsModalVisible(false)
  }

  return { isModalVisible, handleConfirmNavigation, handleCancelNavigation }
}
